<template>
	<div>
		<div class="popBoxBg" v-show="show"></div>
		<div class="popBox" v-show="show">
			<div class="inner">
				<img src="../../assets/ok.png" >
				<h3>打印成功</h3>
				<p>	
					请取走报告单
				</p>
				<p>
					{{time321}}秒后自动返回首页
				</p>
				<div class="fcc">
					<div class="button-blue" @click="close">
						确定
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'q-pop-print',
		// props: {
		// 	msg: String
		// },
		data() {
			return {
				//timer:null,
				show:true,
				timer:null,
				time321:60
			}
		},
	
		
		mounted() {
			var that = this;
			that.timer = setInterval(function() {
				that.time321--
				if (that.time321 < 1) {
					//60秒不操作就返回首页
					that.openUrl('/index')
				}
			}, 1000)
		},
		methods: {
			close(){
				this.show=false
				this.$emit('close-read',false); 
				clearTimeout(this.timer);
			}
		},
		beforeDestroy() {
			clearTimeout(this.timer);
		}
		
	}
</script>

<style scoped lang="less">
		.inner{
			padding-top:102px;
			text-align: center;
			img{
				height: 273px;
				margin-bottom: 60px;
			}
			h3{
				font-size: 66px;
				font-weight: 800;
				color: #3C90F0;
				line-height: 100px;
				
			}
			p{
				font-size: 38px;
				color: #333333;
			}
			p+p{
				margin-top: 10px;
				color: #828282;
				margin-bottom: 82px;
			}
		}
</style>
